import { CardGridWrapper, Page, Topbar } from 'components'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Pages, RoutingParams } from 'routes'
import { AuthStore, RoutingStore } from 'stores'
import { DataType, UserType, ICurriculum } from 'types'
import { ParticipantView, CourseListEditor, MainSidebar } from 'views'
import { Curriculum } from 'models'
import { useParams } from 'react-router'


export interface ICoursesProps {
  authStore?:    AuthStore,
  routingStore?: RoutingStore,
}

export const Courses = inject('routingStore', 'authStore')(observer((props: ICoursesProps) => {
  const { t } = useTranslation();
  const { authStore, routingStore } = props;
  const params: RoutingParams = useParams<RoutingParams>();

  return (
    <Page sidebar={<MainSidebar />} topbar={<Topbar showBackButton={Boolean(params.id)} />}>
      {authStore.getCurUserType === UserType.Editor ?
        <CourseListEditor />
        : 
        (Boolean(params.id) ?
          <ParticipantView contentType={DataType.Course} />
          : 
          <CardGridWrapper 
            showSorting
            showFiltering
            useCatalog
            contentType = {DataType.Course}
            title       = {t('courses')}
            desc        = {t('manager_courses_description')}
            onCardClick = {(c: Curriculum<ICurriculum>) => routingStore.push(Pages.Courses, {id: ""+c.id})}
          />
        )
      }
    </Page>
  )
}));
